/**
 * Environment Manager initialization
 * Auto-starts the environment manager to apply saved preferences.
 */
import { EnvironmentManager } from './environment-manager.js';

EnvironmentManager.init();
